import { render, staticRenderFns } from "./default-client.vue?vue&type=template&id=1bf60c02&scoped=true"
import script from "./default-client.vue?vue&type=script&lang=js"
export * from "./default-client.vue?vue&type=script&lang=js"
import style0 from "./default-client.vue?vue&type=style&index=0&id=1bf60c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf60c02",
  null
  
)

export default component.exports